import {get, merge} from 'lodash';

import localeCodes from 'resources/Locales';

import r7enUS from './en/r7-US';
import enUS from './en/US';
import jaJP from './ja/JP';
import r7jaJP from './ja/r7-JP';
import koKR from './ko/KR';
import r7koKR from './ko/r7-KR';
import zhCN from './zh/CN';
import r7zhCN from './zh/r7-CN';
import r7zhTW from './zh/r7-TW';
import zhTW from './zh/TW';

const enUSCode = localeCodes.en;
const locales = {
  [localeCodes.en]: enUS,
  [localeCodes.jaJP]: jaJP,
  [localeCodes.koKR]: koKR,
  [localeCodes.zhCN]: zhCN,
  [localeCodes.zhTW]: zhTW,
  [localeCodes.zhHK]: zhTW,
};
const r7Locales = {
  [localeCodes.en]: r7enUS,
  [localeCodes.jaJP]: r7jaJP,
  [localeCodes.koKR]: r7koKR,
  [localeCodes.zhCN]: r7zhCN,
  [localeCodes.zhTW]: r7zhTW,
  [localeCodes.zhHK]: r7zhTW,
};

export function getResources(locale) {
  return merge({}, get(r7Locales, locale), get(locales, locale));
}

export function mapLocaleFromUnderscoreToHyphen(locale) {
  return locale.split('_').join('-');
}

export default function load(locale, resources = {}) {
  if (!resources[locale]) {
    resources[locale] = getResources(locale);

    if (!resources[enUSCode]) {
      resources[enUSCode] = getResources(enUSCode);
    }
  }

  return resources;
}
